import { getStyle } from '@utils/style';
import { ReactComponent as Check } from '@icons/check.svg';
import { ReactElement } from 'react';

interface CheckBoxProps {
  name: string;
  value?: boolean;
  title: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CheckBox = ({ name, value = false, title, onChange }: CheckBoxProps): ReactElement => {
  return (
    <label
      className="styled-checkbox"
      style={{
        color: value ? getStyle('PRIMARY_COLOR', true) : getStyle('INPUT_PLACEHOLDER_COLOR', true),
        fontSize: getStyle('INPUT_FONT_SIZE', true)
      }}
    >
      <input type="checkbox" name={name} onChange={onChange} checked={value} />
      <span>{value && <Check />}</span>
      {title}
    </label>
  );
};
